import * as React from 'react';
import type { HelpTopic } from '@chess/api-help';

// The help topic behind the card's "?": how the columns are counted, in
// plain words. Registered by this plugin's setup.
export const MIDDLEGAME_TURNS_HELP = 'middlegame.turns';

export const middlegameTurnsHelp: HelpTopic = {
  title: 'When it turns',
  body: (
    <>
      <p>
        This card shows when, in the middlegame, you give up score: early, just out of the opening, or late, as the game gets long. It looks at your scanned
        middlegames of the last 30 days.
      </p>
      <h3>What a column measures</h3>
      <p>
        Every one of your own moves in the middlegame is compared with the engine's score before and after it, in pawns. A move that made your position worse
        gave up the difference; a move that improved it gives nothing back. The moves are grouped by move number: up to move 15, then five moves at a time, and
        move 36 on.
      </p>
      <p>
        A column's height is the pawns your moves in those move numbers gave up <b>per middlegame</b>: everything they gave up, divided by the middlegames you
        played moves of there (a column's tooltip gives that number). So a column every game reaches and one few games reach read on the same scale:
        −1.84 means that, on average, your moves there cost you almost two pawns a game.
      </p>
      <p>
        Scores are capped at ten pawns either way, so a missed mate counts as a big loss but not an endless one.
      </p>
      <h3>Reading it</h3>
      <p>
        Tall columns on the left mean you drift soon after the opening: plans and piece placement. Tall columns on the right mean you lose the thread late,
        often with less time on the clock. Few games reach the late moves, so a late column rests on fewer games: its tooltip says how many.
      </p>
      <p>
        Clicking a column opens the games that <b>turned</b> there: where your moves in those move numbers gave up at least <b>half a pawn</b> in all. Its
        tooltip says how many.
      </p>
    </>
  ),
};
